// extracted by mini-css-extract-plugin
module.exports = {"image-drop":"image-placeholder_image-drop__Rx2RU","altText":"image-placeholder_altText__genDT"};